module.exports = __webpack_public_path__ + "static/media/S3N1.af25b369.svg";